export default __webpack_public_path__ + "static/media/todo-screenshot-04.6dc41327.png";